import { environment } from '../../environments/environment';

export const AppConfig = {
  apiUrl: environment.apiUrl,
  version: '1.5.2',
  isTest: !environment.production && environment.isTest,
  defaultStorageMode: 'local',
  bugsnagApiKey: '1847944dd8df7281b5480468620eb5fe',
};
